import { render } from "./SubmitSimple.vue?vue&type=template&id=47760cac&scoped=true&ts=true"
import script from "./SubmitSimple.vue?vue&type=script&lang=ts"
export * from "./SubmitSimple.vue?vue&type=script&lang=ts"

import "./SubmitSimple.vue?vue&type=style&index=0&id=47760cac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47760cac"]])

export default __exports__